// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileSeeMoreDescription__link-cd2f2d {
  cursor: pointer;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--brand-primary-40);
  text-align: left;
  display: inline-block;
  white-space: nowrap;
  box-sizing: border-box;
  width: 100%;
}

.ProfileSeeMoreDescription__link-cd2f2d:hover,
.ProfileSeeMoreDescription__link-cd2f2d:focus {
  color: var(--brand-primary-50);
  text-decoration: none;
}

.ProfileSeeMoreDescription__link-cd2f2d:active {
  color: var(--brand-primary-60);
  text-decoration: none;
}

.ProfileSeeMoreDescription__show-more-c5fdb5 {
  display: inline;
}

.ProfileSeeMoreDescription__hide-ff3405 {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/components/ProfileSeeMoreDescription/ProfileSeeMoreDescription.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;;EAEE,8BAAA;EACA,qBAAA;AACF;;AAEA;EACE,8BAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".link {\n  cursor: pointer;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--brand-primary-40);\n  text-align: left;\n  display: inline-block;\n  white-space: nowrap;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.link:hover,\n.link:focus {\n  color: var(--brand-primary-50);\n  text-decoration: none;\n}\n\n.link:active {\n  color: var(--brand-primary-60);\n  text-decoration: none;\n}\n\n.show-more {\n  display: inline;\n}\n\n.hide {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `ProfileSeeMoreDescription__link-cd2f2d`,
	"show-more": `ProfileSeeMoreDescription__show-more-c5fdb5`,
	"showMore": `ProfileSeeMoreDescription__show-more-c5fdb5`,
	"hide": `ProfileSeeMoreDescription__hide-ff3405`
};
module.exports = ___CSS_LOADER_EXPORT___;
